import apiClient from './api';

export const pontoService = {
  // Registrar ponto (entrada, pausa, saída)
  async registrar({ tipo, latitude, longitude, observacao, selfie }) {
    const formData = new FormData();
    formData.append('tipo', tipo);
    formData.append('latitude', latitude);
    formData.append('longitude', longitude);
    if (observacao) formData.append('observacao', observacao);
    if (selfie) formData.append('selfie', selfie);

    return apiClient.post('/ponto/registrar', formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
  },

  // (opcional) Histórico de registros do usuário
  async getHistorico() {
    return apiClient.get('/ponto/meus');
  },

  async getStatus() {
    return apiClient.get('/ponto/status');
  },

  async getEntradaDoDia() {
    return apiClient.get('/ponto/entrada-dia');
  },

  async getRegistrosPorData(data) {
    return apiClient.get('/ponto/meus', {
      params: { data } // envia ?data=YYYY-MM-DD
    });
  },

  async getRelatorioPeriodo(start, end) {
    return apiClient.get('/ponto/relatorio', {
      params: { start, end }
    });
  },

  async getEspelhoPonto(start, end) {
    return apiClient.get('/ponto/espelhoPonto', {
      params: { start, end }
    });
  }
  
};
